import inoxTables from './inox_tables';

const inox = [
  {
    id: "inox-tube-rond",
    title: "Tube rond inox 304L/316L",
    image: "/assets/images/products/inox/inox-tube-rond.webp",
    specImage: null,
    description: "Tubes ronds inox 304L et 316L selon ASTM A312 pour le transport de fluides",
    longDescription: "Conformes à la norme ASTM A312, ces tubes ronds en 304L et 316L sont destinés au transport de fluides dans tout type d'industries. Le 316L, enrichi en molybdène, est conseillé pour les milieux les plus corrosifs.",
    category: "inox",
    specifications: [
      "Norme: ASTM A312",
      "Nuances: 304L (1.4307) ou 316L (1.4404)",
      "Diamètres extérieurs: de 6mm à 114,3mm",
      "Épaisseur: de 1mm à 3,05mm selon diamètre",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-rond"]
  },
  {
    id: "inox-tube-carre",
    title: "Tube carré inox",
    image: "/assets/images/products/inox/inox-tube-carre.webp",
    specImage: null,
    description: "Tubes inox de section carrée pour structures, menuiserie et décoration",
    longDescription: "Le tube carré inox combine rigidité et esthétique. Il est très utilisé en menuiserie métallique, pour les portails, garde-corps, mobilier et structures légères exposées aux intempéries.",
    category: "inox",
    specifications: [
      "Normes: EN 10305-5, EN 10219-2",
      "Nuance: 304 (1.4301)",
      "Dimensions: de 16x16mm à 120x120mm",
      "Épaisseur: de 1mm à 4mm selon dimensions",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-carre"]
  },
  {
    id: "inox-tube-rectangulaire",
    title: "Tube rectangulaire inox",
    image: "/assets/images/products/inox/inox-tube-rectangulaire.webp",
    specImage: null,
    description: "Tubes inox de section rectangulaire pour structures et agencement",
    longDescription: "Le tube rectangulaire inox apporte une bonne résistance à la flexion avec un rendu moderne. Il est apprécié pour les cadres, châssis, mains courantes, enseignes et mobilier.",
    category: "inox",
    specifications: [
      "Normes: EN 10305-5, EN 10219-2",
      "Nuance: 304 (1.4301)",
      "Dimensions: de 30x15mm à 100x40mm",
      "Épaisseur: de 1mm à 3mm selon dimensions",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-rectangulaire"]
  },
  {
    id: "inox-tube-rond-din",
    title: "Tube rond DIN",
    image: "/assets/images/products/inox/inox-tube-rond-din.webp",
    specImage: null,
    description: "Tubes inox sanitaires DIN pour les installations agroalimentaires",
    longDescription: "Fabriqués selon la norme DIN 11850 et soudés laser, ces tubes présentent une surface intérieure lisse qui limite la rétention de matière et facilite le nettoyage. Le 304L DIN est destiné à l'agroalimentaire et aux industries des boissons, le 316L DIN aux industries pharmaceutiques.",
    category: "inox",
    specifications: [
      "Normes: EN 10217-7 TC1, DIN 11850",
      "Nuances: 304L DIN (1.4307) ou 316L DIN (1.4404)",
      "Soudure: laser",
      "Diamètres extérieurs: de 28mm à 104mm",
      "Épaisseur: 1,5mm ou 2mm",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-rond-din"]
  },
  {
    id: "inox-tube-rond-sms",
    title: "Tube rond SMS",
    image: "/assets/images/products/inox/inox-tube-rond-sms.webp",
    specImage: null,
    description: "Tubes inox sanitaires SMS en 304L et 316L pour les lignes alimentaires",
    longDescription: "Conformes à la norme SMS 3008, ces tubes sanitaires sont compatibles avec les raccords SMS utilisés dans les laiteries, les brasseries, les usines de jus et l'industrie pharmaceutique. Leur surface lisse facilite le nettoyage en place et limite les dépôts.",
    category: "inox",
    specifications: [
      "Normes: EN 10217-7 et SMS 3008",
      "Nuances: 304L (1.4307) ou 316L (1.4404)",
      "Diamètres extérieurs: de 25,4mm à 101,6mm (jusqu'à 76,1mm en 316L)",
      "Épaisseur: de 1,2mm à 2mm",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-rond-sms"]
  },
  {
    id: "inox-tube-rond-304l-316l",
    title: "Tube rond 304L/316L",
    image: "/assets/images/products/inox/inox-tube-rond-304l-316l.webp",
    specImage: null,
    description: "Tubes ronds inox soudés laser ou HF pour fluides et construction mécanique",
    longDescription: "Cette gamme couvre une très large plage de diamètres. Les tubes soudés laser sont destinés au transport de fluides dans tous les secteurs industriels, tandis que les tubes soudés HF conviennent à la construction générale, à la mécanique et aux pièces destinées au traitement thermique.",
    category: "inox",
    specifications: [
      "Normes: EN 10217-7 TC1, ISO 1127 D3-T3",
      "Nuances: 304L (1.4307) ou 316L (1.4404)",
      "Soudure: laser (transport de fluides) ou HF (construction et mécanique)",
      "Diamètres extérieurs: de 10mm à 508mm (jusqu'à 323,9mm en 316L)",
      "Épaisseur: de 0,8mm à 4mm selon diamètre",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-rond-304l-316l"]
  },
  {
    id: "inox-tube-rond-304l",
    title: "Tube rond 304L",
    image: "/assets/images/products/inox/inox-tube-rond-304l.webp",
    specImage: null,
    description: "Tubes ronds inox soudés HF pour la construction générale et mécanique",
    longDescription: "Économiques et polyvalents, ces tubes soudés HF sont destinés à la construction générale, à la mécanique, au mobilier et aux ouvrages décoratifs comme les rampes et les garde-corps.",
    category: "inox",
    specifications: [
      "Normes: EN 10296-2, EN ISO 1127 D3/T3, EN 10305-5, EN 10219-2, ASTM A554",
      "Nuance: 304 (1.4301)",
      "Soudure: HF",
      "Diamètres extérieurs: de 10mm à 114,3mm",
      "Épaisseur: de 1mm à 2mm selon diamètre",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-rond-304l"]
  },
  {
    id: "inox-tube-schedule",
    title: "Tube rond schedule 10/40",
    image: "/assets/images/products/inox/inox-tube-schedule.webp",
    specImage: null,
    description: "Tubes inox schedule 10 et 40 pour tuyauteries industrielles",
    longDescription: "Dimensionnés selon la norme ASTM A312, les tubes schedule 10 et 40 sont destinés au transport de fluides dans les industries pétrolières, chimiques et gazières, en environnement corrosif ou à haute température.",
    category: "inox",
    specifications: [
      "Norme: ASTM A312",
      "Nuances: 304L (1.4307) ou 316L (1.4404)",
      "Schedule 10: diamètres de 21,3mm à 219,1mm",
      "Schedule 40: diamètres de 21,3mm à 114,3mm",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-tube-schedule"]
  },
  {
    id: "inox-raccords-vannerie",
    title: "Raccords et vannerie inox",
    image: "/assets/images/products/inox/inox-raccords-vannerie.webp",
    specImage: null,
    description: "Coudes, tés, brides, raccords et vannes inox pour réseaux de fluides",
    longDescription: "Pour compléter vos lignes de tuyauterie, nous proposons une gamme de raccords et de vannes en inox compatibles avec nos tubes. Ils garantissent l'étanchéité et l'hygiène des installations industrielles et alimentaires.",
    category: "inox",
    specifications: [
      "Normes: AISI, SMS, DIN, Schedule, ASTM",
      "Nuances: 304L ou 316L",
      "Coudes, tés et réductions",
      "Brides, colliers et collerettes",
      "Vannes et clapets",
      "Boulonnerie"
    ],
    tables: inoxTables["inox-raccords-vannerie"]
  },
  {
    id: "inox-tole-alimentaire",
    title: "Tôle alimentaire inox",
    image: "/assets/images/products/inox/inox-tole-alimentaire.webp",
    specImage: null,
    description: "Tôles inox adaptées au contact alimentaire et aux environnements hygiéniques",
    longDescription: "Non poreuse et facile à désinfecter, la tôle inox alimentaire est la référence pour les cuisines professionnelles, les plans de travail, les hottes, les chambres froides et les équipements de transformation alimentaire.",
    category: "inox",
    specifications: [
      "Normes: EN 10088-2, ASTM A240",
      "Nuances: 304L (1.4307) ou 316L (1.4404)",
      "Épaisseur: de 0,4mm à 20mm",
      "Formats: 1000x2000mm, 1250x2500mm, 1500x3000mm selon épaisseur",
      "Découpe et pliage sur demande"
    ],
    tables: inoxTables["inox-tole-alimentaire"]
  },
  {
    id: "inox-tole-larmee",
    title: "Tôle larmée inox",
    image: "/assets/images/products/inox/inox-tole-larmee.webp",
    specImage: null,
    description: "Tôles inox à relief antidérapant pour sols, marches et plateformes",
    longDescription: "Grâce à son relief en larmes, la tôle larmée inox assure une bonne adhérence tout en résistant à l'humidité et aux produits de nettoyage. Elle est utilisée pour les planchers de camions, les marches d'escalier, les passerelles et les sols des locaux techniques ou alimentaires.",
    category: "inox",
    specifications: [
      "Épaisseur: de 2mm à 4mm",
      "Formats: 1000x2000mm, 1250x2500mm, 1500x3000mm",
      "Surface: relief antidérapant en larmes",
      "Découpe sur mesure disponible"
    ],
    tables: inoxTables["inox-tole-larmee"]
  },
  {
    id: "inox-bobine",
    title: "Bobine inox laminée à froid",
    image: "/assets/images/products/inox/inox-bobine.webp",
    specImage: null,
    description: "Bobines d'acier inoxydable laminées à froid pour la fabrication en série",
    longDescription: "Nos bobines inox laminées à froid offrent une surface régulière et une épaisseur constante sur toute la longueur. Elles alimentent les lignes de refendage, de découpe et de profilage pour la production de pièces en série, d'équipements de cuisine ou d'éléments d'habillage.",
    category: "inox",
    specifications: [
      "Laminage: à froid",
      "Épaisseur: de 0,6mm à 3mm",
      "Largeur: 1000mm, 1250mm ou 1500mm",
      "Refendage et découpe à longueur sur demande"
    ],
    tables: inoxTables["inox-bobine"]
  },
  {
    id: "inox-bobine-laminee-chaud",
    title: "Bobine inox laminée à chaud",
    image: "/assets/images/products/inox/inox-bobine-laminee-chaud.webp",
    specImage: null,
    description: "Bobines d'acier inoxydable laminées à chaud en fortes épaisseurs",
    longDescription: "Laminées à chaud, ces bobines inox en fortes épaisseurs sont destinées à la fabrication de pièces robustes : cuves, réservoirs, châssis, équipements industriels et pièces découpées ou pliées.",
    category: "inox",
    specifications: [
      "Laminage: à chaud",
      "Épaisseur: de 4mm à 6mm",
      "Largeur: 1000mm, 1250mm ou 1500mm",
      "Refendage et découpe à longueur sur demande"
    ],
    tables: inoxTables["inox-bobine-laminee-chaud"]
  },
  {
    id: "inox-tole-decorative",
    title: "Tôle décorative inox",
    image: "/assets/images/products/inox/inox-tole-decorative.webp",
    specImage: null,
    description: "Tôles inox à finition décorative pour façades, agencement et mobilier",
    longDescription: "La tôle inox décorative apporte une finition haut de gamme aux habillages de façades, ascenseurs, comptoirs, cuisines et éléments de mobilier. Elle allie esthétique durable et facilité d'entretien.",
    category: "inox",
    specifications: [
      "Normes: EN 10028-7, ASTM A240",
      "Nuance: 430 (1.4016)",
      "Épaisseur: de 0,4mm à 2mm",
      "Format: 1000x2000mm",
      "Découpe et pliage sur demande"
    ],
    tables: inoxTables["inox-tole-decorative"]
  },
  {
    id: "inox-rond-plein",
    title: "Rond plein inox",
    image: "/assets/images/products/inox/inox-rond-plein.webp",
    specImage: null,
    description: "Barres pleines en inox pour usinage et fabrication",
    longDescription: "Les barres pleines inox servent à la fabrication d'axes, de pièces usinées, de supports ou d'éléments décoratifs. Elles offrent une bonne usinabilité et une excellente tenue à la corrosion.",
    category: "inox",
    specifications: [
      "Normes: ASTM A276 / A470, EN 10088-3, tolérance H9",
      "Largeurs: de 20mm à 100mm",
      "Épaisseur: de 3mm à 10mm selon largeur",
      "Découpe à longueur sur demande"
    ],
    tables: inoxTables["inox-rond-plein"]
  },
  {
    id: "inox-corniere",
    title: "Cornière inox",
    image: "/assets/images/products/inox/inox-corniere.webp",
    specImage: null,
    description: "Cornières inox à ailes égales pour ossatures, supports et finitions",
    longDescription: "La cornière inox sert de renfort, de support ou d'élément de finition. On la retrouve dans les châssis, cadres, rails, protections d'angles et ouvrages exposés à l'humidité.",
    category: "inox",
    specifications: [
      "Nuances: 304 / 304L (1.4301 / 1.4307)",
      "Dimensions: de 20x20mm à 100x100mm",
      "Épaisseur: de 3mm à 10mm selon dimensions",
      "Longueur standard: 6m"
    ],
    tables: inoxTables["inox-corniere"]
  }
];

export default inox;
